
import DropdownGroup from './DropdownGroup.vue'

export default {
  name: 'DropdownGroupsContent',

  components: {
    DropdownGroup,
  },

  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getDescription(tab) {
      if (typeof tab.featuredIntro === 'string') {
        return tab.featuredIntro
      }

      return JSON.stringify(tab.featuredIntro || '')
    },
  },
}
